export default __webpack_public_path__ + "static/media/ring-gif.a0fe1f37.gif";